<template>
  <EntityList
    :config="config"
    :columns="columns"
    :form-fields="formFields"
    authority="General_Prefecture"
  />
</template>

<script>
import EntityList from '@/layouts/entity/EntityList.vue'
import storeModule from './storeModule'

export default {
  components: {
    EntityList,
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'prefectures',
        endpoint: 'prefectures',
        route: 'prefectures',
        title: {
          single: this.$i18n.t('Prefecture'),
          plural: this.$i18n.t('Prefectures'),
        },
      }
    },

    columns() {
      return [
        { key: 'id', label: this.$t('id'), sortable: true },
        { key: 'title', label: this.$t('title'), sortable: true },
        { key: 'actions', label: this.$t('actions') },
      ]
    },
    formFields() {
      return [
        {
          id: 'title',
          type: 'text',
          label: this.$t('title'),
          required: true,
        },
        {
          id: 'code',
          type: 'text',
          label: this.$t('code'),
        },
        {
          id: 'description',
          type: 'textarea',
          label: this.$t('description'),
        },
      ]
    },
  },
}
</script>
